import { render, staticRenderFns } from "./WelcomeSection.vue?vue&type=template&id=14c22e3d&scoped=true&"
import script from "./WelcomeSection.vue?vue&type=script&lang=js&"
export * from "./WelcomeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c22e3d",
  null
  
)

export default component.exports